import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaRegCopy } from 'react-icons/fa';
import SubmitButton from './SubmitButton'; // ajuste o caminho conforme necessário
import styles from './ModalCopyLink.module.scss'; // ajuste o nome conforme seu CSS Modules
import { alertModal } from '../utils/modalController';

const CopyIcon = FaRegCopy as React.FC<{ size?: number; color?: string }>;

interface ModalCopyLinkProps {
    show: boolean;
    onClose: () => void;
    urlPath?: string;
}

const ModalCopyLink: React.FC<ModalCopyLinkProps> = ({
    show,
    onClose,
    urlPath,
}) => {
    const fullUrl = `${window.location.origin}/${urlPath}`;

    const handleCopy = () => {
        navigator.clipboard.writeText(fullUrl)
            .then(() => alertModal('Texto copiado!'))
            .catch((err) => console.error('Erro ao copiar:', err));
    };

    return (
        <Modal
            show={show}
            className={styles.modal}
            onHide={onClose}
            centered
        >
            <Modal.Header closeButton onHide={onClose} className={styles["modal-header"]}>
                <Modal.Title>Formulário</Modal.Title>
            </Modal.Header>

            <Modal.Body className={styles["modal-body"]}>
                <div className={styles["copy-text-container"]}>
                    <Button
                        variant="light"
                        size="sm"
                        className={styles["btn-copy"]}
                        onClick={handleCopy}
                    >
                        <CopyIcon size={12} /> Copiar
                    </Button>

                    <div id="copyText">{fullUrl}</div>
                </div>
            </Modal.Body>

            <Modal.Footer className={styles["modal-footer"]}>
                <SubmitButton
                    type="button"
                    onClick={onClose}
                    className={styles["btn-modal"]}
                >
                    Fechar
                </SubmitButton>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalCopyLink;
